import { call, put, takeLatest } from "redux-saga/effects";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";

import {
  WastageSaveAPI,
  WastageFilterAPI,
  WastageSingleGetAPI,
  WastageUpdateAPI,
  WastageDeleteAPI,
  WastageExcelAPI,
} from "../../../helpers/backend_helper";

import {
  wastageSaveSuccess,
  wastageSaveFail,
  wastageFilterSuccess,
  wastageFilterFail,
  wastageSingleGetSuccess,
  updateWastageListSuccess,
  deleteWastageIdSuccess,
  updateWastageListFail,
  wastageExcelReportSuccess,
  wastageExcelReportFail,
} from "./action";

import {
  WASTAGE_SAVE,
  WASTAGE_FILTER,
  WASTAGE_SINGLE_GET,
  WASTAGE_UPDATE,
  WASTAGE_DELETE,
  WASTAGE_EXCEL_REPORT,
} from "./actionType";


const formatDateWithTime = (isoString, withTime = true) => {
  if (!isoString) return "";

  const date = new Date(isoString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  if (!withTime) {
    return `${day}-${month}-${year}`;
  }

  const time = date.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${day}-${month}-${year} ${time}`;
};


/* ================= SAVE ================= */
function* Post_Wastage_Generator({ payload }) {
  try {
    const response = yield call(WastageSaveAPI, payload);
    // ✅ success alert
    if (response.Status === true && response.StatusCode === 200) {
      customAlert({
        Type: 1, // success
        Message: response.Message,
      });
      yield put(wastageSaveSuccess(response)); // ✅ ONLY DISPATCH
    } else {
      customAlert({
        Type: 4,
        Message: response.Message,
      });
      yield put(wastageSaveFail(response))
    }
    // ✅ dispatch success

  } catch (error) {
    yield put(wastageSaveFail(error));
  }
}


/* ================= FILTER ================= */
function* Get_WastageList_Generator({ payload }) {
  try {
    const response = yield call(WastageFilterAPI, payload);

    const formattedData = (response.Data || []).map(item => ({
      ...item,
      recordsAmountTotal: Number(item.GrandTotal),
      WastageDate: `${formatDateWithTime(item.WastageDate, false)} (${formatDateWithTime(item.CreatedOn)})`,
    }));


    yield put(wastageFilterSuccess(formattedData));
  } catch (error) {
    yield put(wastageFilterFail(error));
  }
}

/* ================= EDIT / SINGLE GET ================= */
function* Edit_Wastage_Generator({ config }) {
  const { btnmode } = config;
  try {
    const response = yield call(WastageSingleGetAPI, config);
    response["pageMode"] = btnmode
    if (response.StatusCode === 200) {
      yield put(wastageSingleGetSuccess(response));
    }
  } catch (error) {
    console.error(error);
  }
}


/* ================= UPDATE ================= */
function* Update_Wastage_Generator({ payload }) {
  try {
    const response = yield call(WastageUpdateAPI, {
      updateId: payload.id,
      jsonBody: payload.data,
    });

    if (response.Status === true && response.StatusCode === 200) {
      yield put(updateWastageListSuccess(response));
    } else {
      customAlert({
        Type: 4,
        Message: response.Message,
      });

      // ✅ STOP LOADER
      yield put(updateWastageListFail(response));
    }
  } catch (error) {
    const errRes = error?.response?.data;

    customAlert({
      Type: 4,
      Message: errRes?.Message || "Update failed",
    });

    // ✅ STOP LOADER
    yield put(updateWastageListFail(errRes));
  }
}


/* ================= DELETE ================= */
function* Delete_Wastage_Generator({ config }) {
  try {
    // 🛑 SAFETY CHECK (VERY IMPORTANT)
    if (!config?.deleteId) {
      customAlert({
        Type: 4,
        Message: "Invalid delete id",
      });
      return;
    }

    const response = yield call(WastageDeleteAPI, {
      deleteId: config.deleteId,   // ✅ PASS EXPLICITLY
    });

    if (response.StatusCode === 200) {
      yield put(
        deleteWastageIdSuccess({
          ...response,
          deletedId: config.deleteId, // ✅ needed for reducer filter
        })
      );
    } else {
      customAlert({
        Type: 4,
        Message: response.Message,
      });
    }
  } catch (error) {
    customAlert({
      Type: 4,
      Message: "Delete failed",
    });
  }
}

function* fetchWastageExcelReport({ payload }) {
  try {
    // WastageExcelAPI = (jsonBody) => post(url.WASTAGE_EXCEL_REPORT, jsonBody)
    // so we pass payload straight through — no extra wrapping/stringifying
    const response = yield call(WastageExcelAPI, payload);
    yield put(wastageExcelReportSuccess(response));
  } catch (error) {
    yield put(wastageExcelReportFail(error));
  }
}


/* ================= WATCHER ================= */
function* WastageSaga() {
  yield takeLatest(WASTAGE_SAVE, Post_Wastage_Generator);
  yield takeLatest(WASTAGE_FILTER, Get_WastageList_Generator);
  yield takeLatest(WASTAGE_SINGLE_GET, Edit_Wastage_Generator);
  yield takeLatest(WASTAGE_UPDATE, Update_Wastage_Generator);
  yield takeLatest(WASTAGE_DELETE, Delete_Wastage_Generator);
  yield takeLatest(WASTAGE_EXCEL_REPORT, fetchWastageExcelReport);
}

export default WastageSaga;
